<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex x16>
        <v-card>
          <v-card-title>
            <v-text-field v-model="search" type="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mr-0" @click="openModalCreate">New device</v-btn>
          </v-card-title>
          <v-data-table
              :headers="headers"
              :items="devices"
              :items-per-page="5"
              class="elevation-5"
              :search="search"
          >
          <template slot="headerCell" slot-scope="props">
            <span>{{ props.header.text }}</span>
          </template>
          
          <template slot="items" slot-scope="props">
            <td>{{ props.item.client.name }}</td>
            <td class="">{{ props.item.name }}</td>
            <td class="">{{ props.item.reference }}</td>
            <td class="">{{ props.item.status ? 'ACTIVE' : 'INACTIVE'}}</td>
            <td class="">{{ props.item.group }}</td>
            <td class="">{{ props.item.token.toUpperCase() }}</td>
            <td class="justify-center layout px-0">
              <div class="text-center d-flex">
                <v-btn class="mr-0" icon @click="openModalCreate(); editItem(props.item, props.index);">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon @click="deleteItem(props.item, props.index)">
                  <v-icon color="red">delete</v-icon>
                </v-btn> 
              </div>
            </td>
          </template>
          
        </v-data-table>
      <ModalCreate v-if="showModalCreate" v-on:closeModal="closeModalCreate" v-on:addDevice="addDeviceList" :itemEdit="selectItemActive" v-on:updateDevice="updateDeviceList" v-on:openModalSummary="openModalSummary"></ModalCreate>
      <ModalDelete v-if="showModalDelete" v-on:closeModal="closeModalDelete" :itemDelete ="selectItemActive" v-on:deleteDevice="deleteDeviceList"></ModalDelete>
      <ModalSummary v-if="showModalSummary" v-on:closeModal="closeModalResumen" :items="uploadSummary"></ModalSummary>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import ModalCreate from './ModalCreate.vue';
import ModalDelete from './ModalDelete.vue';
import ModalSummary from './ModalSummary.vue';

export default {
  components: {
    ModalCreate,
    ModalDelete,
    ModalSummary
  },
  data () {
    return {
      search: '',
      showModalCreate: false,
      showModalDelete: false,
      showModalSummary: false,
      selectItemActive: null,
      uploadSummary: null,
      select: '',
      name: null,
      token: null,
      reference: null,
      type: 'random',
      excelName: '',
      excelFile: null,
      pagination: {
        rowsPerPage: 25
      },
      headers: [
        {
          text: 'Client',
          align: 'left',
          sortable: true,
          value: 'client',
        },
        { text: 'Name', value: 'name' },
        { text: 'Reference', value: 'reference' },
        { text: 'Status', value: 'status' },
        { text: 'Group', value: 'group' },
        { text: 'Token', value: 'token' },
        { text: 'Actions', value: 'actiions', sortable: false }
      ],
      devices: [],
    };
  },
  computed: {
    ...mapGetters(['loading', 'clients', 'client'])
  },
  watch: {
  },
  mounted () {
    this.loadData();
  },
  methods: {
    deleteItem (item, index) {
      item.index = index;
      this.selectItemActive = item;
      this.showModalDelete = true;
    },
    closeModalDelete (item) {
      this.showModalDelete = false;
      this.selectItemActive = null;
    },
    deleteDeviceList (device) {
      this.devices.splice(device, 1);
      this.showModalDelete = false;
      this.selectItemActive = null;
    },
    openModalCreate () {
      this.showModalCreate = true;
    },
    closeModalCreate () {
      this.selectItemActive = null;
      this.showModalCreate = false;
    },
    addDeviceList (device) {
      this.devices.unshift(device);
    },
    editItem (item, index) {
      item.index = index;
      this.selectItemActive = item;
    },
    updateDeviceList (item) {
      this.devices[item.index].name = item.value.name;
      this.devices[item.index].reference = item.value.reference;
      this.devices[item.index].token = item.value.token;
      this.devices[item.index].init_survey = item.value.init_survey;
    },
    pickFile () {
      this.$refs.excelInput.click();
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.excelName = files[0].name;
        if (this.excelName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.excelFile = files[0];
        });
      } else {
        this.excelName = '';
        this.excelFile = '';
      }
    },
    loadData () {
      this.$store.commit('setLoading', true);
      let url = '/devices';
      window.axios.get(url).then((response) => {
        this.devices = response.data.data;
        this.$store.commit('setLoading', false);
      });
    },
    closeModalResumen () {
      this.showModalSummary = false;
      this.uploadSummary = null;
      this.loadData();
    },
    openModalSummary (item) {
      this.uploadSummary = item;
      this.showModalSummary = true;
    }
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
  .color{
    display: block;
    width: 50px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/devices/List.vue